<template>
  <!--修改房费-->
  <div class="price-component">
    <div class="order-price-all" v-show="isShowPrice">
      <div>房费：</div>
      <div class="order-price-text">￥{{ detailPrice }}</div>
    </div>
    <div class="order-price-all" v-show="!isShowPrice">
      <div>房费：</div>
      <span>￥</span>
      <el-input-number v-model="orderPrice" :min="0" controls-position="right" @input="handleChange"></el-input-number>
    </div>
    <el-button v-show="isShowPrice && showType == 'all'" type="primary" icon="Edit" class="order-edit-btn" @click="handleEditPrice">手动修改</el-button>
    <!-- <el-button v-show="!isShowPrice && showType == 'all'" type="primary" class="order-edit-btn" @click="handleEditPrice">取消修改</el-button> -->
  </div>
</template>

<script>
export default {
  name: "orderPriceComponent",
  props: {
    modelValue: [Number, String],
    showType: String,
  },
  data() {
    return {
      isShowPrice: true,
      detailPrice: "",
      orderPrice: "",
    };
  },
  watch: {
    modelValue(val) {
      // 用来干嘛的？不知道，注释了
      // if (this.detailPrice == "") {
        this.detailPrice = val;
        this.orderPrice = val;
        if (this.showType == "isInput") {
          this.isShowPrice = false;
        }
      // }
    },
  },
  methods: {
    //修改价格
    handleEditPrice() {
      this.isShowPrice = !this.isShowPrice;
      if (this.isShowPrice) {
        this.orderPrice = this.detailPrice;
        this.$emit("update:modelValue", this.orderPrice);
      }
    },
    //修改房价
    handleChange(val) {
      this.$emit("update:modelValue", val);
    },
  },
};
</script>

<style lang="less" scoped>
.price-component {
  font-size: 18px;
  line-height: 25px;
  display: flex;
}
.order-price-all {
  color: #333;
  line-height: 33px;
  display: flex;
  .el-input {
    width: 80px;
  }
}
.order-price-text {
  color: red;
}
.order-edit-btn {
  background: transparent;
  font-size: 14px;
  color: #00c0c0;
  padding: 6px 10px;
}
</style>

